<template>
  <div>
    <CSPLoader v-if="loading" />
    <v-container v-else class="touch-view-container">
      <v-card flat>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <span class="font-weight-medium">Image</span>
              <p class="font-weight-light mb-0">
                Save clock in/out images of employee
              </p>
              <v-switch class="mt-0" v-model="metadata.customClockIn.storeTimeClockImage" color="teal" :label="metadata.customClockIn.storeTimeClockImage
                  ? 'Enabled'
                  : 'Disabled'
                "></v-switch>
            </v-col>
            <v-col cols="12" v-if="metadata.customClockIn.storeTimeClockImage">
              <span class="font-weight-medium">View</span>
              <p class="font-weight-light mb-0">
                Show image view on time clock screen
              </p>
              <v-switch class="mt-0" v-model="metadata.customClockIn.storeTimeClockImageView" color="teal" :label="metadata.customClockIn.storeTimeClockImageView
                  ? 'Show'
                  : 'Hide'
                "></v-switch>
            </v-col>
            <v-col cols="12">
              <span class="font-weight-medium">Department</span>
              <p class="font-weight-light mb-0">
                Enabling this feature will allow you to show departments in timeclock screen
              </p>
              <v-switch class="mt-0" v-model="metadata.customClockIn.showDepartment" color="teal" :label="metadata.customClockIn.showDepartment
                  ? 'Show'
                  : 'Hide'
                "></v-switch>
            </v-col>
            <!-- <v-col cols="12" >
              <span class="font-weight-medium">Department</span>
              <p class="font-weight-light mb-0">
                This feature allows you to organize employees into different departments.
              </p>
              <v-switch class="mt-0" v-model="metadata.customClockIn.department" color="teal" :label="metadata.customClockIn.department
                  ? 'Show'
                  : 'Hide'
                "></v-switch>
            </v-col> -->
            <v-divider></v-divider>
            <v-col cols="12">
              <span class="font-weight-medium">Default Work Hours</span>
              <p class="font-weight-light mb-0">
                Default hours value, this value will use if work hours not set
              </p>
              <v-text-field type="tel" v-model="metadata.customClockIn.defaultWorkingHours" outlined
                :error-messages="workingHoursError" dense></v-text-field>
            </v-col>
            <v-col cols="12">
              <span class="font-weight-medium">Clocked In Employees limit </span>
              <p class="font-weight-light mb-0">
                Numbers of employee can clock in simultaneously
              </p>
              <v-text-field type="tel" v-model="metadata.customClockIn.allowedNumberOfClockedInEmployees" outlined
                :error-messages="allowedNumberOfClockedInEmployeesError" dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="font-weight-medium">Time Zone</span>
              <p class="font-weight-light mb-0">
                Allow users to view reports in different time zone
              </p>
            </v-col>
            <v-col cols="12">
              <v-autocomplete v-model="selectedTimeZone" :items="timeZones" outlined dense
                label="Select Time Zone"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="purple" @click="update">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import settingService from "@/modules/Settings/service.js";
import authService from "@/modules/Authentication/service.js";
// import integrationService from "@/modules/Integration/service.js";
// import { mapGetters } from "vuex";
import locationService from "@/modules/Location/service.js";
const { validationMixin } = require("vuelidate");
const { integer, required } = require("vuelidate/lib/validators");

export default {
  data() {
    return {
      loading: true,
      timeZones: [],
      selectedTimeZone: null,
      locationCode: null,
      general: {},
      location: null,
      integration: null,
      metadata: {
        customClockIn: {
          storeTimeClockImage: false,
          showDepartment: false,
          defaultWorkingHours: 12,
          storeTimeClockImageView: false,
          // department: false,
          allowedNumberOfClockedInEmployees: 20
        },
      },
    };
  },
  created() {
    this.timeZones = this.$moment.tz.names();
    this.selectedTimeZone = localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}timezone`)
    this.locationCode = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}code`
    );
    this.getLocation();
    this.getGeneral();
  },
  // computed: {
  //   ...mapGetters("global", ["getLocation"]),
  // },
  mixins: [validationMixin],
  validations: {
    metadata: {
      customClockIn: {
        defaultWorkingHours: {
          required,
          integer,
        },
        allowedNumberOfClockedInEmployees: {
          required,
          integer,
        },
      },
    },
  },
  computed: {
    allowedNumberOfClockedInEmployeesError() {
      const errors = [];
      if (!this.$v.metadata.customClockIn.allowedNumberOfClockedInEmployees.$dirty) return errors;
      if (!this.$v.metadata.customClockIn.allowedNumberOfClockedInEmployees.required) errors.push("Field Is Required");
      if (!this.$v.metadata.customClockIn.allowedNumberOfClockedInEmployees.integer)
        errors.push("Please enter number");
      return errors;
    },
    workingHoursError() {
      const errors = [];
      if (!this.$v.metadata.customClockIn.defaultWorkingHours.$dirty) return errors;
      if (!this.$v.metadata.customClockIn.defaultWorkingHours.required) errors.push("Field Is Required");
      if (!this.$v.metadata.customClockIn.defaultWorkingHours.integer)
        errors.push("Please enter number");
      return errors;
    },
  },
  methods: {
    getLocation() {
      this.loading = true;
      authService.getLocation(this.locationCode).then((response) => {
        // console.log("location", response);
        response.data.Integrations.map((row) => {
          if (row.pubSubHook === "TERMINALTIMECLOCK") {
            this.integration = row;
            console.log(row);
          }
        });
        if (response.data.metadata && response.data.metadata.customClockIn) {
          console.log("in custom close in ");
          this.metadata = {
            ...this.metadata,
            ...response.data.metadata,
          };
        } else {
          if (this.integration) {
            this.metadata = {
              ...this.metadata,
              ...this.integration.LocationIntegration.metadata,
            };
          }
        }
        this.location = response.data;
        this.loading = false;
      });
    },
    getGeneral() {
      this.loading = true;
      return settingService.getGeneral().then((response) => {
        console.log("response", response);
        this.general = response.data;
        this.loading = false;
      });
    },
    update() {
      this.$v.$touch();
      localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}timezone`, this.selectedTimeZone);
      this.$moment.tz.setDefault(this.selectedTimeZone);
      if (this.$v.$invalid) {
        this.$toast.error("Missing Fields", { timeout: 2000 });
        this.loadingBtn = false;
      } else {
        locationService.Terminal.update(this.location.id, {
          metadata: this.metadata,
        })
          .then((res) => {
            console.log("res", res);
            this.$toast.success("Setting was updated", { timeout: 2000 });
            this.$router.push({ name: "settings-index" });
          })
          .catch((err) => {
            this.$toast.error(err.data ? err.data.message : "Error", {
              timeout: 2000,
            });
          });
      }
    },
  },
};
</script>

<style scoped>
.touch-view-container {
  height: calc(100vh - 170px);
  overflow: auto;
}
</style>